import {
  ONDACERO,
  DEFAULT_SITE,
  ANTENA3,
  LA_SEXTA,
  isLaRazon
} from 'constants/sites';

export const MODULE_TYPES = {
  HOME: 'HOME',
  PACTOS: 'PACTOS',
  HOME_DOBLE: 'HOME_DOBLE',
  RANKING: 'RANKING',
  BARRAS: 'BARRAS',
  HOME_NOT_CENTRALIST: 'HOME_NOT_CENTRALIST',
  MINI: 'MINI',
  BUTTONS: 'BUTTONS',
  PACT_SI_O_NO: 'PACT_SI_O_NO',
  HOME_DETAIL: 'HOME_DETAIL'
};

export const MODULES_A3 = {
  RESULTADOS: 'Resultados',
  PACTOMETRO: 'Pactometro',
  BARRAS: 'Comparativa de escaños',
  BUTTONS: 'Generador de enlaces'
};

export const MODULES_LASEXTA_G = {
  RESULTADOS: 'Resultados',
  PACTOMETRO: 'Pactometro',
  RANKING: 'Ranking',
  MINI: 'Suma de bloques',
  BUTTONS: 'Generador de enlaces'
};

export const MODULES_LASEXTA_PV = {
  RESULTADOS: 'Resultados',
  PACTOMETRO: 'Pactometro',
  RANKING: 'Ranking',
  BUTTONS: 'Generador de enlaces'
};

export const MODULES_ONDACERO = {
  RESULTADOS: 'Resultados',
  PACTOMETRO: 'Pactometro',
  BUTTONS: 'Generador de enlaces'
};

export const DOUBLE_MODULE = {
  HOME_DOBLE: 'Resultados Dobles'
};

export const NO = 'No navegable';
export const NEWS = 'Navegable news';
export const STATIC = 'Navegable static';
export const NAV = [NO, NEWS, STATIC];
export const isOndaCero = site =>
  site === ONDACERO || window.location.hostname.includes(ONDACERO);
export const isAntena3 = site =>
  site === ANTENA3 || window.location.hostname.includes(ANTENA3);
export const isLaSexta = site =>
  site === LA_SEXTA || window.location.hostname.includes(LA_SEXTA);

/**
 *
 * @deprecated
 */
export const getSiteDeprectated = () => {
  if (window.location.hostname.includes(ONDACERO)) {
    return ONDACERO;
  }
  if (window.location.hostname.includes(ANTENA3)) {
    return ANTENA3;
  }
  if (window.location.hostname.includes(LA_SEXTA)) {
    return LA_SEXTA;
  }
  return DEFAULT_SITE;
};

const basename = process.env.PUBLIC_URL || '/';

export const getAmpDomain = path =>
  window.location.href
    .replace('/generador.html', path)
    .replace('www.larazon', 'amp.larazon')
    .replace('pre.larazon', 'pre-amp.larazon');

export const getModuleAmp = (path, height = 800, urlImg, componentType) =>
  `<amp-iframe
  class="amp-iframe-elecciones amp-iframe-elecciones--${componentType}"
  width="750"
  height="${height}"
  sandbox="allow-popups allow-scripts allow-same-origin allow-top-navigation"
  layout="responsive"
  frameborder="0"
  style="height: ${height}px; margin-bottom: 20px;"
  resizable
  src="${getAmpDomain(path)}#amp=1">
    <amp-img
      placeholder
      overflow
      layout="fill"
      src="${urlImg}"
      hidden >
    </amp-img>
</amp-iframe>`;

export const getModuleWeb = (
  moduleId,
  url,
  siteId,
  ineId,
  year,
  electionType,
  subtype,
  electionNumber,
  componentType,
  place
) => `<div id="${moduleId}" class="election-module election-module--${componentType} election-module--${subtype} election-module--${place}">
  ${
    url.includes('resultados.html')
      ? `<link rel="stylesheet" type="text/css" href="${window.location.origin}${basename}/static/css/main.css">
  <esi:include src="/cmselections/v1/esi/modulehtmlelection/${siteId}/${year}/${electionType}/${subtype}/${electionNumber}/${ineId}?typePage=NEWS"/>`
      : ''
  }
</div>

<script>
var cssId = "myCss"; // you could encode the css path itself to generate id..
var scriptId = "myScript"; // you could encode the css path itself to generate id..
if (!document.getElementById(cssId)) {
  var head = document.getElementsByTagName("head")[0];
  var link = document.createElement("link");
  link.id = cssId;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "${window.location.origin}${basename}/static/css/main.css";
  link.media = "all";
  head.appendChild(link);

  var script = document.createElement("script");
  script.setAttribute(
    "src",
    "${window.location.origin}${basename}/static/js/main.js"
  );
  script.id = scriptId;
  script.onload = function() {
    document.dispatchEvent(new CustomEvent("script-load"));

    window.atresmedia_elecciones(document.getElementById('${moduleId}'),"${url}")

  };
  document.body.appendChild(script);
} else {
  document.addEventListener("script-load", function(e) {
    window.atresmedia_elecciones(document.getElementById('${moduleId}'),"${url}")

  });
}
</script>`;

export const getModuleOCWeb = (
  moduleId,
  url,
  height = 800,
  siteId = '2',
  ineId,
  year,
  electionType,
  subtype,
  electionNumber,
  componentType,
  place
) =>
  `${
    url.includes('resultados.html')
      ? `<link rel="stylesheet" type="text/css" href="${window.location.origin}${basename}/static/css/main.css">
<script type="text/javascript" src="${window.location.origin}${basename}/static/js/main.js"></script>`
      : ''
  }<div>
<atres-widget
  id="${moduleId}"
  class="election-module election-module--${componentType} election-module--${subtype} election-module--${place}""
  style="display: block;"
  data-type="external"
  data-src="${window.location.origin}${basename}/static/js/main.js"
  data-css="${window.location.origin}${basename}/static/css/main.css"
  data-wait-for="atresmedia_elecciones"
  data-onload="while (element !== element.parentElement.firstChild) {element.parentElement.removeChild(element.parentElement.firstChild);} window.atresmedia_elecciones(element,'${url}')">
    ${
      url.includes('resultados.html')
        ? `<esi:include src="/cmselections/v1/esi/modulehtmlelection/${siteId}/${year}/${electionType}/${subtype}/${electionNumber}/${ineId}?typePage=NEWS"/>`
        : ''
    }
</atres-widget></div>`;
